<template>
  <div class="a">
    <Nav/>
    <PageBannerSmall :banner="banner"></PageBannerSmall>
    <About/>
    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerSmall from '@/components/PageBannerSmall'
import About from '@/components/About'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerSmall,
    About,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/about-banner.jpg"),
        title: "人工智能",
        sub: "人工智能的成功有可能是人类文明史上最大的事件"
      }
    }
  }
}
</script>

<style scoped lang="less">
.a{
  .b{
    font-size: 30px;
  }
}
</style>